import { SortDirection } from '../constants/direction'


interface BaseResponse {
    version: number | '', // empty in dev mode
    update_at?: string,
}

export interface FailedResponse extends BaseResponse {
    success: false,
    error?: string,
    field_errors?: {
        [key: string]: string[]
    },
}

export interface SuccessResponse extends BaseResponse {
    success: true,
}

export type EmptyResponse = SuccessResponse | FailedResponse

export interface MultipleRowsResponse<Row> extends SuccessResponse {
    rows: Row[],
    total: number,
}

export interface SingleRowResponse<Row> extends SuccessResponse {
    row: Row,
}

export type ListResponse<Row> = FailedResponse | MultipleRowsResponse<Row>

export type RowResponse<Row> = FailedResponse | SingleRowResponse<Row>

export type DeleteResponse = FailedResponse | { success: true, row: number }

export interface Query {
    sort?: SortDirection | {
        key?: string,
        order: SortDirection,
    },
    limit?: number,
    offset?: number,
    search?: string,
    search_full?: string,
}

export enum RequestStatus {
    INITIAL = 'INITIAL',
    FETCHING = 'FETCHING',
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE',
}
